import { PropsWithChildren } from "react";
import { useNavigate } from "react-router-dom";

import { PartDto } from "#modules/parts/infra/fetchPart.api";
import { PreviewError } from "#modules/similarPart/view/errors/PreviewError";
import { ROUTES } from "#shared/routes";
import { JobStatusSchema } from "shared";

export const PreviewErrorCheck = ({ part, children }: { part: PartDto } & PropsWithChildren) => {
  const navigate = useNavigate();
  const isPreviewError = part.previewStatus === JobStatusSchema.enum.ERROR;

  if (isPreviewError) {
    const resetSearch = () => {
      navigate(ROUTES.partnerIaSearch);
    };

    return <PreviewError onRetry={resetSearch} />;
  }

  return children;
};
